const fashionMetadataAlwaysEnabled = () => (publication, remove = false) => {
  if (!remove) {
    publication.metadata = { fashion: { enabled: true }, ...publication.metadata }
  }

  return publication
}

export { fashionMetadataAlwaysEnabled }